module.exports = __webpack_public_path__ + "img/loginBg.505e2999.jpg";